import React, { useEffect, useState } from "react";
import { PurchasedCompany } from "../../../components/admin/Dashboard/purchased/PurchasedCompany";
import { PurchasedCompanyCard } from "../../../components/admin/Dashboard/purchased/PurchasedCompanyCard";
import FollowNewCom from "../../../components/admin/Dashboard/following/FollowNewCompanies";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as PurchaseCompany } from "../../../assets/icons/PurchaseCompany.svg";
import { Card, Button } from "../../../components/common/index.js";
import { useGetUserPurchaedDataQuery } from "../../../store/Company/companyApiSlice";

const Purchased = () => {
  const { userInfo, token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation()
  const [count, setCount] = useState(0);
  const [sortedArray, setSortedArray] = useState([]);

  const { data } = useGetUserPurchaedDataQuery({
    token: token,
    id: userInfo?.individual[0]?.userID,
  });
  const checkworldboxStatus = (value) => {
    const filteredLocalServerData = data?.orders?.filter(
      (item) => item.companyID === value
    );
    if (filteredLocalServerData?.length > 0) {
      if (filteredLocalServerData[0]['status'] == "available") {
        return "no_worldbox";
      } else {
        return filteredLocalServerData[0]['status'];
      }
    } else {
      return "no_worldbox";
    }
  }

  useEffect(() => {
    const mergedArray = data?.data?.map((item1) => {
      if (item1.companyID?.startsWith("TRX")) {
        return item1;
      } else{
        const order = data?.orders?.find((order) => +item1?.order_id === order?.id);
        return order
      }
    }) ?? [];

    // Compare and sort based on the latest date
    const sortedArrayData = mergedArray?.sort((a, b) => {
      const dateA = new Date(a.purchaseDate || a.dateCreated);
      const dateB = new Date(b.purchaseDate || b.dateCreated);
      return dateB - dateA;
    });
        
    setSortedArray(sortedArrayData)
  }, [location, data]);

  return (
    <>
      <div className="flex flex-col sm:grid grid-cols-10 gap-4 h-full">
        <div className="w-full col-start-1 col-end-8 mb-10">
          <PurchasedCompany />
          {sortedArray.length === 0 ? (
            <>
              <div className="flex flex-col items-center gap-5 justify-center w-1/3 mx-auto p-5 pkpp">
                <PurchaseCompany />
                <span className="text-secondary text-f14 w-2/3">
                  All your Purchases will appear here
                </span>
                <Button
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate("/plans");
                  }}
                  classes="border-link text-f14 text-link font-semibold border py-2 px-5 rounded"
                >
                  Start Purchasing
                </Button>
              </div>
            </>
          ) : (
            <>
              {sortedArray?.length > 0 && sortedArray?.map(
                (company) =>
                (
                  <PurchasedCompanyCard
                    status={checkworldboxStatus(company?.companyID)}
                    company={company?.companyID}
                    companyData={company}
                    token={token}
                    is_expired={company?.is_expired}
                    expired_date={company?.expireDate}
                  />
                )
              )}
            </>
          )}
        </div>
        <div className="w-full col-start-8 col-end-11 flex flex-col">
          <FollowNewCom type="order_request" />
        </div>
      </div>
    </>
  );
};

export default Purchased;
